const i18n = require('./json/en.json');

export default i18n;
